export default "__VITE_ASSET__ede4709b__"